import React from 'react';
import Legal from '../Legal';

const Privacy = () => {
    return (
        <Legal title="Privacy Policy" lastUpdated="January 1, 2026">
            <h3>1. Introduction</h3>
            <p>
                Welcome to ARIVUNEST ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy.
                If you have any questions or concerns about our policy, or our practices with regards to your personal information, please contact us at privacy@arivunest.com.
            </p>

            <h3>2. Information We Collect</h3>
            <p>
                We collect personal information that you voluntarily provide to us when expressing an interest in obtaining information about us or our products and services,
                when participating in activities on the Services (such as posting messages in our online forums or entering competitions, contests or giveaways)
                or otherwise contacting us.
            </p>
            <ul>
                <li><strong>Personal Data:</strong> Name, Email address, Phone number, Password, Contact preferences.</li>
                <li><strong>Payment Data:</strong> We may collect data necessary to process your payment if you make purchases, such as your payment instrument number (such as a credit card number), and the security code associated with your payment instrument.</li>
                <li><strong>Audio Data:</strong> As part of our AI-driven communication and language training, we collect and process voice recordings to provide feedback on pronunciation, fluency, and clarity. These recordings are processed securely and are not used for any other purpose.</li>
            </ul>

            <h3>3. How We Use Your Information</h3>
            <p>
                We use personal information collected via our Services for a variety of business purposes described below:
            </p>
            <ul>
                <li>To provide and manage your account.</li>
                <li>To send administrative information to you (e.g., changes to our terms, conditions, and policies).</li>
                <li>To fulfill and manage your orders.</li>
                <li>To post testimonials (with your consent).</li>
                <li>To request feedback and to contact you about your use of our Services.</li>
                <li>To protect our Services (e.g., fraud monitoring and prevention).</li>
            </ul>

            <h3>4. Sharing Your Information</h3>
            <p>
                We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.
                We may process or share data based on the following legal basis:
            </p>
            <ul>
                <li><strong>Consent:</strong> We may process your data if you have given us specific consent to use your personal information in a specific purpose.</li>
                <li><strong>Legitimate Interests:</strong> We may process your data when it is reasonably necessary to achieve our legitimate business interests.</li>
                <li><strong>Performance of a Contract:</strong> Where we have entered into a contract with you, we may process your personal information to fulfill the terms of our contract.</li>
            </ul>

            <h3>5. Cookie Policy</h3>
            <p>
                We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store information. Specific information about how we use such technologies
                and how you can refuse certain cookies is set out in our Cookie Policy.
            </p>

            <h3>6. Contact Us</h3>
            <p>
                If you have questions or comments about this policy, you may email us at privacy@arivunest.com or by post to:
                <br /><br />
                ARIVUNEST<br />
                Legal Dept, Tech Park<br />
                Bangalore, Karnataka, India
            </p>
        </Legal>
    );
};

export default Privacy;
